import { render } from "./trend.vue?vue&type=template&id=a43a17f8"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"

import "./trend.vue?vue&type=style&index=0&id=a43a17f8&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__